if (!customElements.get('mobile-sticky-bar')) {
  class MobileStickyBar extends HTMLElement {
    connectedCallback() {
      this.hidden = true;
      var sectionId = this.dataset.sectionId;
      var atcBtn = document.getElementById('ProductSubmitButton-' + sectionId);
      if (!atcBtn) return;
      var self = this;
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          self.hidden = entry.isIntersecting;
        });
      }, { threshold: 0.1 });
      observer.observe(atcBtn);
      this.querySelector('.mobile-sticky-bar__atc').addEventListener('click', function(e) {
        e.preventDefault();
        atcBtn.click();
      });
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);
}
